import Styled from 'styled-components';

export const Line = Styled.div`
	position: relative;
    overflow: hidden;
	height: auto;
`;
export const BottomOneLevelTableRow = Styled.div`

box-sizing: border-box;
display: flex;
justify-content: stretch;
align-items: center;
height: 28px;
background: white;
padding-left: ${({numberOfParents}) =>
	numberOfParents === 1 ? '48px;' : numberOfParents === 2 ? '92px;' : numberOfParents === 0 && '16px;'}


${props => (props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'z-index:1;' : '')};
${props => (props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'position:sticky;' : '')};
${props => (props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'top: 84px;' : '')};

`;

export const BottomOneLevelItem = Styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
box-sizing: border-box;
padding-right: 16px;
width:166px;
height: 10px;
order: ${props => props.order};

.blurry-text {
	box-sizing: border-box;
	background-color: #e6e6ed;
	border-radius: 2px;
	 filter: blur(4px); 
	 width: 80%;
	height: 10px;	
	} 
	
`;

export const BottomOneLevelRightItem = Styled.div`
display: flex;
justify-content: flex-end;
align-items: center;
box-sizing: border-box;
padding-right: 16px; 
width: 166px;
height: 100%;
order: ${props => props.order};

.blurry-text {
	box-sizing: border-box;
	background-color: #e6e6ed;
	border-radius: 2px;
	filter: blur(4px);
	width: 80%;
	height: 10px;	
	}
`;

export const BottomOneLevelDetailItem = Styled.div`
display: grid;
flex:1;
align-items: center;
box-sizing: content-box;
min-width: 166px;
height: 100%;
padding-right: 16px;
order: ${props => props.order};
.blurry-text {
	box-sizing: border-box;
	background-color: #e6e6ed;
	border-radius: 2px;
	filter: blur(4px);
	width: 80%;
	height: 10px;	
	}
`;
